import { FC } from 'react';
import { useStoryDetailContext } from '#advertStory/detail';
import storyDetailHeaderDescriptionCss from '../../assets/detail/story-detail-header-description.module.scss';

const StoryDetailHeaderDescription: FC = () => {
  const { story } = useStoryDetailContext();

  return (
    <div className={storyDetailHeaderDescriptionCss.storyDetailHeaderDescription}>
      <div>
        {story.advert.name}
      </div>
      <div className={storyDetailHeaderDescriptionCss.storyDetailHeaderDescription__time}>
        {story.time}
      </div>
    </div>
  );
};

export { StoryDetailHeaderDescription };
